import { MprcAppBar } from "components/MprcAppBar";
import { MprcContainer } from "components/MprcContainer";
import * as React from "react";

interface IProps {
    children?: React.ReactNode | undefined;
    margin?: MprcMargin;
}

export const MprcFilterAppBar: React.FC<IProps> = ({ children, margin }) => {
    return (
        <MprcContainer margin={margin}>
            <MprcAppBar position="static" color="default" headerColor="white" >
                {children}
            </MprcAppBar>
        </MprcContainer>
    );
};
